import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';
import ImageUpload from '../../components/ImageUpload';


const InterviewForm = () => {
  
  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoader, setIsLoader] = useState(false);
  const [currency] = useState(process.env.REACT_APP_CURRENCY);
  const [categories, setCategories] = useState([]);
  
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    duration_type: '',
    duration: '',
    price: '',
    thumbnail: '',
    video: '',
  });



  useEffect(() => {
    if (id) {
      getSingleData();
    }
    getCategoryies();
  }, [id]);

  const capitalizeText = (text) => {
    return text
      .split(' ')  // Split the text into words
      .map(word => 
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()  // Capitalize the first letter of each word
      )
      .join(' ');  // Join the words back into a single string
  };

  const getSingleData = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `interviews/${id}`, // Replace with your API endpoint
      });
      const data = response.data;
      if (data.status) {
        setFormData(data.data);
        
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };

  const getCategoryies = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `categories/list`, // Replace with your API endpoint
      });
      const data = response.data;
      if (data.status) {
        setCategories(data.data);
        
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handleImageChange = (name, file) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: file,
    }));
  };
  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    // console.log(file);
    setFormData((prevFormData) => ({
      ...prevFormData,
      ['video']: file,
    }));
    console.log(formData);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);

    try {
      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });

      const response = await ApiService.request({
        method: 'POST',
        url: `interviews/createOrUpdate/${id || ''}`, // Replace with your API endpoint
        data,
      });

      if (response.data.status) {
        toast.success(response.data.message);
        navigate('/interviews');
      } else {
        toast.error(response.data.message);
      }
      setIsLoader(false);
    } catch (error) {
      console.error('Form submission failed:', error);
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              {id ? 'Edit' : 'Add New'} Course
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <Link to="/dashboard" className="text-muted text-hover-primary">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                <Link to="/interviews" className="text-muted text-hover-primary">Courses</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <div className="card-body pt-0">
              <form onSubmit={handleSubmit} className="form fv-plugins-bootstrap5 fv-plugins-framework">
                <div className="row g-9 my-3">
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2"> Title</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Enter Course Title"
                      required
                      name="title"
                      value={formData.title}
                      onChange={handleChange}
                    />
                  </div>
                  
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2"> Category</label>
                    <select name="category_id" required onChange={handleChange} value={formData.category_id || ""}
                    className="form-select form-control-solid">
                      <option value="">Select Category</option>
                      { categories.map((cat, index) => (
                       <option value={cat.id} key={index}>{cat.title}</option>
                      ))}
                    </select>
                  </div>


                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2"> Duration</label>
                    <select name="duration_type" required onChange={handleChange} value={formData.duration_type || ""}
                    className="form-select form-control-solid">
                      <option value="">Select Type</option>
                      <option value="month">Month</option>
                      <option value="year">Years</option>
                    </select>
                  </div>

                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2"> Number of {capitalizeText(formData.duration_type) || ""} </label>
                    <input
                      type="number" 
                      className="form-control form-control-solid"
                      placeholder="Enter number of duration"
                      required
                      name="duration"
                      value={formData.duration}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2"> Price ({currency}) </label>
                    <input
                      duration="number" step={0.01}
                      className="form-control form-control-solid"
                      placeholder="Enter Package Price"
                      required
                      name="price"
                      value={formData.price}
                      onChange={handleChange}
                    />
                  </div>
                  
                  <div className="col-md-12 fv-row fv-plugins-icon-container">
                    <label className=" fs-6 fw-semibold mb-2"> Description</label>
                    <textarea name="description"  rows="4"  className="form-control form-control-solid" placeholder='Enter Course Description'
                     onChange={handleChange} value={formData.description}>{formData.description}</textarea>
                  </div>


                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className=" fs-6 fw-semibold mb-2">Thumbnail</label>
                    <ImageUpload name="thumbnail" onImageChange={handleImageChange} defaultPreviewUrl={formData.thumbnail} />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className=" fs-6 fw-semibold mb-2">Upload Video</label>
                    <input type="file" name='video' className='form-control' onChange={handleVideoChange}  accept="video/*"  />
                  </div>
                  

                </div>


                  


             

                <div className="row g-9 my-3">
                  <div className="text-center">
                    <Link to={`/interviews`} className="btn btn-light me-3">Back</Link>
                    <button type="submit" className="btn btn-base" disabled={isLoader}>
                      <span className="indicator-label">{isLoader ? <Loader size="20" color="white" text="Submitting" /> : 'Submit'}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewForm;
